import { Alert } from 'reactstrap';

export default function OrganizationNotFound() {
    return (
        <div className='p-3 m-0'>
            <Alert color='warning'><span className="alert-icon"><i className="fa-solid fa-triangle-exclamation"></i></span>Please select an organization</Alert>
        </div>
    )
}